<amplify-authenticator *transloco="let t" [hideSignUp]="true" [loginMechanisms]="['email']">
  <ng-template amplifySlot="sign-in-header">
    <div class="justify-content-center text-center mt-3">
      <h3>
        {{ t('sign-in.header') }}
      </h3>
    </div>
  </ng-template>
  <app-toasts />
  @if (isAuthenticated()) {
    <div class="secured-content">
      <img
        id="fabota-img"
        class="img-fluid d-none d-md-block"
        src="../assets/images/header_logo.png"
        alt="header image" />
      <app-navbar />
      <div class="m-3">
        <router-outlet />
      </div>
    </div>
  }
</amplify-authenticator>
